import type { SeedListData } from '@openx/types/segments.ts';
import type { Dispatch } from 'react';
import { dispatchAddItem } from './dispatchers.ts';
import type { Action } from './types.ts';

export const addItem = (item: SeedListData, prevValue: SeedListData[], dispatch: Dispatch<Action>) => {
  const updatedValue = [...prevValue, item];

  dispatchAddItem(dispatch, item);
  return updatedValue;
};
